// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom"; // ✅ CORRECT

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" }); // or "smooth"
  }, [pathname]);          //  ⬑ fires on every route change

  return null;             // this component renders nothing
}
